



















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// types
import { Settings } from "@/services/templates/types";
// validation
import validate from "@/directives/validate";
import { settingsValidators } from "@/components/templates/validators";

@Component({
    directives: {
        validate
    }
})
export default class TemplateSettings extends Vue {
    @Prop() settings!: Settings;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localSettings = {} as Settings;
    validators = settingsValidators;
    // Watchers
    @Watch("settings")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localSettings = this.settings;
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods

    emitData() {
        this.$emit("settingsUpdated", JSON.stringify(this.localSettings));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "TemplateSettings", state: state });
    }
}
